import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { Feedback } from 'types'

interface Data {
  feedback: Feedback
}

export interface Variables {
  rating: string
  feedback?: any
  subject: { type: 'AISuggestionRequest' | 'BrandKit'; id: number }
}

export const createFeedback = async ({ rating, feedback, subject }: Variables) => {
  const res = await sendToApi<Data>(`/feedbacks`, {
    method: 'POST',
    body: {
      rating,
      feedback,
      subject,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export interface Options extends Omit<UseMutationOptions<Feedback, Error, Variables>, 'mutationFn'> {}

export const useCreateFeedback = (options?: Options) => {
  return useMutation<Feedback, Error, Variables>(async (vars) => {
    const result = await createFeedback(vars)

    return result.feedback
  }, options)
}
